
import { Component, Vue } from "vue-property-decorator";
import housedetail from "@/template/house/houseDetail.vue";
@Component
export default class houseDetail extends housedetail {
  mounted() {}
}
